<section class="service-request-wrapper">
  @if (!isLoading && !errorMessage && !successMessage) {
    <div class="service-request-card">
      <header class="service-request-header">
        <div>
          <p class="campaign-label">Solicitud de servicio</p>
          <h1 class="service-title">
            {{ serviceDetails?.name || 'Servicio en preparación' }}
          </h1>
          <p class="service-description">
            {{ serviceDetails?.description }}
          </p>
        </div>
        @if (serviceDetails?.file?.url) {
          <img
            class="service-cover"
            [src]="serviceDetails?.file?.url"
            [alt]="serviceDetails?.name"
            />
        }
      </header>
      <section class="service-body">
        <div class="info-block">
          <h2>Datos del solicitante</h2>
          <p>
            <span class="info-label">Email:</span>
            {{ requestMetadata?.email }}
          </p>
          @if (clientDetails?.name) {
            <p>
              <span class="info-label">Nombre:</span>
              {{ clientDetails?.name }}
            </p>
          }
        </div>
        @if (clientAddresses.length) {
          <div class="info-block addresses">
            <div class="addresses-header">
              <div>
                <h2>Domicilios guardados</h2>
                <p class="helper-text">
                  Elegí el domicilio donde necesitás el servicio.
                </p>
              </div>
            </div>
            <div class="address-grid">
              @for (address of clientAddresses; track trackAddressById($index, address)) {
                <div
                  class="address-card"
                  [ngClass]="{ 'selected-address': isAddressSelected(address) }"
                  tabindex="0"
                  role="button"
                  (click)="selectAddress(address)"
                  (keydown)="onAddressKeydown($event, address)"
                  [attr.aria-pressed]="isAddressSelected(address)"
                  >
                  <mat-card appearance="outlined">
                    <mat-card-title>
                      <span>
                        <mat-icon>
                          {{
                          isAddressSelected(address)
                          ? 'check_circle'
                          : 'check_circle_outline'
                          }}
                        </mat-icon>
                        <h3>
                          {{ address.street }} {{ address.number }}
                        </h3>
                      </span>
                    </mat-card-title>
                    <mat-card-content>
                      <div>
                        <span>
                          @if (address.locationSummary) {
                            <h3>
                              {{ address.locationSummary.description }}
                            </h3>
                          } @else {
                            @if (address.city || address.state) {
                              <h3 class="fallback-location">
                                {{ address.city }}, {{ address.state }}
                              </h3>
                            }
                          }
                        </span>
                      </div>
                    </mat-card-content>
                  </mat-card>
                </div>
              }
            </div>
          </div>
        }
        @if (!clientAddresses.length) {
          <div class="info-block addresses">
            <p>Este cliente todavía no tiene domicilios registrados.</p>
          </div>
        }
        @if (selectedAddressId) {
          <div class="info-block scheduling">
            <h2>Agendá tu visita</h2>
            <p class="helper-text">
              Seleccioná una fecha futura para coordinar el servicio.
            </p>
            <div class="date-picker">
              <label for="service-date">Fecha preferida</label>
              <input
                #serviceDateInput
                id="service-date"
                type="date"
                [min]="minDate"
                [value]="selectedDate || ''"
                (change)="onDateChange($event)"
                (click)="openDatePicker(serviceDateInput)"
                (keydown)="$event.preventDefault()"
                readonly
                />
              </div>
              @if (selectedDate) {
                <div class="time-slot-container">
                  <p class="helper-text">Elegí los rangos horarios que te convienen</p>
                  <div class="slot-chip-group">
                    @for (option of timeSlotOptions; track option) {
                      <button
                        type="button"
                        class="slot-chip"
                        [ngClass]="{ selected: isSlotSelected(option.id) }"
                        (click)="toggleSlot(option.id)"
                        [attr.aria-pressed]="isSlotSelected(option.id)"
                        >
                        {{ option.label }}
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          }
          <div class="action-bar">
            <button
              type="button"
              class="ind-button"
              (click)="onContinue()"
              [disabled]="!selectedAddressId || isSubmitting || isLoading"
              >
              {{ isSubmitting ? 'Enviando...' : 'Continuar' }}
            </button>
            @if (!selectedAddressId) {
              <p class="helper-text">
                Seleccioná un domicilio para continuar.
              </p>
            }
          </div>
        </section>
      </div>
    }

    @if (isLoading) {
      <div class="service-request-state">
        <p>Cargando información del servicio...</p>
      </div>
    }

    @if (errorMessage) {
      <div class="service-request-state error">
        <p>{{ errorMessage }}</p>
        <small>Si el problema persiste, solicite un nuevo enlace.</small>
      </div>
    }

    @if (successMessage) {
      <div class="service-request-state success">
        <p>{{ successMessage }}</p>
      </div>
    }
  </section>

